import React from 'react'
import { RouteChildrenProps } from 'react-router'

import styles from './styles.sass'
import Button from '../../components/Button'
import EmailConfirmationScreen from '../components/EmailConfirmationScreen/EmailConfirmationScreen'
import AuthenticationContainerState from '../../iam/views/AuthenticationContainer/AuthenticationContainerState'

interface Props extends RouteChildrenProps {
  controller: AuthenticationContainerState
}

export default function EmailConfirmedPage(p: Props) {
  return (
    <EmailConfirmationScreen>
      <div className={styles.title}>You're all set!</div>
      <div className={styles.description}>
        Great news! You have confirmed your email and can now sign in to the
        platform.
      </div>
      <div className={styles.signInButton}>
        <Button
          size="cta"
          block
          type="primary"
          onClick={() => p.controller.authorize('login')}
        >
          Sign In
        </Button>
      </div>
    </EmailConfirmationScreen>
  )
}
